import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface ReviewDet {
  id: number;
  customerId: string | null;
  customerName?: string | null;
  replyComment: string;
  createdAt: string;
}

export interface ReviewHdr {
  id: number;
  plant: string;
  productId: string;
  customerId: string | null;
  customerName?: string | null;
  rating: number;
  reviewComment: string;
  showHide: number;
  createdAt: string;
}

export interface ProductReview {
  reviewHdr: ReviewHdr;
  reviewDets: ReviewDet[];
}

export const ProductReviewAdminApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getProductReviewsAdmin: builder.query<
      ResultsDTO<ProductReview[]>,
      { plant: string; productId: string }
    >({
      query: ({ plant, productId }) => ({
        url: "/review-rating/get",
        method: "GET",
        params: { plant, productId },
      }),
      providesTags: ["ProductReviews"],
    }),

    updateProductReview: builder.mutation<
      ResultsDTO,
      {
        id: number;
        plant: string;
        // Customer updates: rating + reviewComment only.
        rating?: number;
        reviewComment?: string;
        // Admin updates: showHide only (approve/hide).
        showHide?: number;
      }
    >({
      query: (body) => ({
        url: "/review-rating/update",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ProductReviews"],
    }),

    replyToReview: builder.mutation<
      ResultsDTO,
      {
        id: number;
        plant: string;
        replyComment: string;
      }
    >({
      query: (body) => ({
        url: "/review-rating/reply",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ProductReviews"],
    }),

    updateReply: builder.mutation<
      ResultsDTO,
      {
        // id of the existing reply record (reviewDets[].id), not the review header id.
        id: number;
        plant: string;
        replyComment: string;
      }
    >({
      query: (body) => ({
        url: "/review-rating/update/reply",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ProductReviews"],
    }),
  }),
});

export const {
  useGetProductReviewsAdminQuery,
  useUpdateProductReviewMutation,
  useReplyToReviewMutation,
  useUpdateReplyMutation,
} = ProductReviewAdminApiSlice;
